/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { FullModalLayout, ImageUplodader } from '@components/molecules'
import { boShared } from '@components/systems/backoffice/backoffice.tokens'

import {
	useAppDispatch,
	useAppSelector,
	routeActions,
	adminUsersActions,
} from '@redux/index'

/** 관리자 → 사용자 프로필 이미지 변경. 업로더 한 장 */
const UserProfileImageUpdatePage = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()
	const selectedUser: { id: string } = useAppSelector(
		state => state.adminUsers.editUserProfileImage,
	)

	const onCloseClick = React.useCallback(() => {
		reduxDispatch(routeActions.NAVIGATE_PATH('/admin/users'))
	}, [])

	const onGetImage = (aFile: File) => {
		reduxDispatch(
			adminUsersActions.UPLDATE_PROFILE_IMAGE({
				userId: selectedUser.id,
				profileImage: aFile,
			}),
		)
	}

	return (
		<View css={style}>
			<FullModalLayout
				title="프로필 이미지 변경"
				onCloseClick={onCloseClick}
				size="small"
			>
				<View className="userProfileImageOuterView">
					<ImageUplodader onGetImage={onGetImage} />
				</View>
			</FullModalLayout>
		</View>
	)
}

export default UserProfileImageUpdatePage

const style = css({
	...boShared,

	'.userProfileImageOuterView': {
		position: 'relative',
		overflow: 'auto',
		textAlign: 'left',
	},
})
